import { useAuthentication } from '../../../Login/hooks/useAuthentication';
import { useMemo } from 'react';
import { LoanType } from '../../../../../../admin/src/loans/common/LoanConstants';
import { useBorrowerLoanType } from '../../../queries/BorrowerFields/CoreFields';

export const useShowTermsheet = () => {
    const { authentication } = useAuthentication();

    const [loanType] = useBorrowerLoanType();

    const showTermsheet = useMemo(() => {
        if (!authentication) return false;
        if (loanType === LoanType.SubNoteConstruction) return false;
        if (loanType === LoanType.SubNoteFixFlip) return false;
        if (
            authentication.user.requireTermsheet === false &&
            (loanType === LoanType.Construction || loanType === LoanType.FixFlip)
        ) {
            return false;
        }

        return true;
    }, [loanType, authentication?.user.requireTermsheet]);

    return { showTermsheet };
};
